import { Modal } from "@/shared/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

type ModalData = {
  modalType: Modal
  component: React.ReactNode
}

type ModalState = {
  modals: ModalData[]
  openModal: (modalType: Modal, component: React.ReactNode) => Modal
  closeModal: (modalType: Modal) => void
}

export const useModalStore = create<ModalState>()(
  devtools(
    set => ({
      modals: [],
      openModal: (modalType, component) => {
        set(
          state => ({ modals: [...state.modals, { modalType, component }] }),
          false,
          { type: "modal/openModal", modalType }
        )
        return modalType
      },
      closeModal: modalType => {
        set(
          state => ({
            modals: state.modals.filter(m => m.modalType !== modalType),
          }),
          false,
          { type: "modal/closeModal", modalType }
        )
      },
    }),
    { name: "ModalStore", enabled: process.env.NODE_ENV === "development" }
  )
)
